import { GoogleUtmRequest } from "@/builder/interfaces";
import { publicApiService } from "@/services/publicApiService";
import { v4 as uuid } from 'uuid';

export class googleAnalyticsService {
    analyticsAccountId: string | null = null;
    clientId: string | null = null;

    constructor() { }

    init = async (analyticsAccountId: string | null) => {
        this.analyticsAccountId = analyticsAccountId;
        return await this.getClientId();
    }

    private getClientId = async () => {
        if (this.clientId) return this.clientId;

        if (!this.analyticsAccountId) return null;

        this.clientId = await this.getAnalyticsClientId(this.analyticsAccountId);
        if (this.clientId) return this.clientId;

        this.clientId = localStorage.getItem("cid");
        if (this.clientId) return this.clientId;

        this.clientId = uuid();
        localStorage.setItem("cid", `${this.clientId}`);
        return this.clientId;
    }

    private getAnalyticsClientId = (analyticsAccountId: string) => {
        return new Promise<string | null>((resolve) => {
            //if gtag client id is available, return it
            // @ts-ignore
            if (window.gtag) {
                // @ts-ignore
                window.gtag("get", analyticsAccountId, "client_id", (clientId) => {
                    clearTimeout(timeout);
                    if (!timeoutReached) {
                        resolve(clientId);
                    }
                });

                //if gtag is blocked by adblocker, return null
                let timeoutReached = false;
                const timeout = setTimeout(() => {
                    timeoutReached = true;
                    console.error("Timeout reached while waiting for Google Analytics client ID.");
                    resolve(null);
                }, 500);
            } else {
                resolve(null);
            }
        });
    }

    trackPageView = async (pageId: string, organizationId: number | null, publicApiService: publicApiService) => {
        const clientId = await this.getClientId();
        publicApiService.pageViewed(pageId, organizationId, clientId);
    }

    trackFormStarted = async (pageId: string, organizationId: number | null, publicApiService: publicApiService) => {
        const clientId = await this.getClientId();
        publicApiService.formStarted(pageId, organizationId, clientId);
    }

    getUtmCodes = () : GoogleUtmRequest =>  {
        //get utm codes from url
        const urlParams = new URLSearchParams(window.location.search);
        return {
            utmCampaign: urlParams.get('utm_campaign'),
            utmSource: urlParams.get('utm_source'),
            utmMedium: urlParams.get('utm_medium'),
            utmContent: urlParams.get('utm_content'),
            utmTerm: urlParams.get('utm_term')
        } as GoogleUtmRequest;
    }
}
